/**
 * Combined page-metadata catalog + shared brand defaults.
 */

import { ADMIN_PAGE_META } from './catalogAdmin';
import { APP_PAGE_META } from './catalogApp';
import {
  DEFAULT_PUBLIC_DESCRIPTION,
  DEFAULT_PUBLIC_TITLE,
  PUBLIC_PAGE_META,
} from './catalogPublic';
import type { PageMetaEntry } from './types';

export const APP_NAME = 'BuzzBit X';

export { DEFAULT_PUBLIC_DESCRIPTION, DEFAULT_PUBLIC_TITLE };

export const DEFAULT_PRIVATE_DESCRIPTION =
  'BuzzBit X workspace — manage customers, automations, inbox, and account settings for your business.';

/** Site origin used when building canonical URLs for public pages. */
export const PUBLIC_ORIGIN = 'https://buzzbitx.com';

/**
 * First matching entry wins. App + admin rows precede public catch-alls so
 * authenticated path prefixes are never shadowed by a public `/` rule.
 */
export const PAGE_META_CATALOG: readonly PageMetaEntry[] = [
  ...APP_PAGE_META,
  ...ADMIN_PAGE_META,
  ...PUBLIC_PAGE_META,
];
